import { commitServerState, type RetagPayload } from '../commands'
import type { useGate } from '../data/useGate'

type GateOutbox = ReturnType<typeof useGate>['outbox']

export interface RetagWaiting {
  key: string
  target: 'BAG' | 'SAMPLE'
  container_id: string | null
  sample_id: string | null
  conflict: string | null
  lot_code: string | null
}

/**
 * Bags and samples the server kept without a tag, from the sync results of this phone's
 * deliveries, less those already re-tagged here (the same list as the full RetagPage).
 */
export function retagWaiting(outbox: GateOutbox): RetagWaiting[] {
  const done = new Set(
    outbox
      .filter((r) => r.type === 'retag')
      .map((r) => {
        const p = r.payload as RetagPayload
        return p.container_id ?? p.sample_id ?? ''
      }),
  )
  const out: RetagWaiting[] = []
  for (const r of outbox) {
    if (r.type !== 'commit_delivery') continue
    const st = commitServerState.safeParse(r.result?.server_state ?? {})
    if (!st.success) continue
    for (const w of st.data.waiting_for_tag) {
      const id = w.container_id ?? w.sample_id ?? ''
      if (!id || done.has(id)) continue
      out.push({
        key: id,
        target: w.target,
        container_id: w.container_id ?? null,
        sample_id: w.sample_id ?? null,
        conflict: w.conflict_qr_payload ?? null,
        lot_code: w.lot_code ?? null,
      })
    }
  }
  return out
}
